import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.img`
${({ displayState, theme }) => css`
    width: ${displayState?.size ? `${displayState?.size}px` : '30px'};
    min-width: ${displayState?.size ? `${displayState?.size}px` : '30px'};
    height: ${displayState?.size ? `${displayState?.size}px` : '30px'};
    border-radius: 50%; 
    border: ${displayState?.noBorder ? '' : `1px solid ${theme?.colour?.primary ?? '#1DBD6B'}`};
    background: ${displayState?.primary ? (theme?.colour?.primary ?? '#1DBD6B') : displayState?.noBackground ? '' : (theme?.colour?.secondary ?? '#04333B')};
    object-fit: cover;
    flex-shrink: 0;
`}
`
export default Atom({ type: 'image', datatype: 'string', template })